import { ActivityIndicator } from "@components/ActivityIndicator";
import { BodySmall } from "@components/Typography";
import { useErrorBanner, useResendInviteToShareGoal } from "@hooks";
import { i18n, Translations } from "@i18n";
import { useStyles } from "@routes/ShareGoalRoute/InviteContactList/InviteContactItem/styles";
import { ResentInviteCTAProps } from "./types";

export const ResendInviteCTA = ({ id }: ResentInviteCTAProps) => {
  const styles = useStyles();

  const { showErrorBanner } = useErrorBanner();

  const [resendInvite, { data, loading }] = useResendInviteToShareGoal();

  const onClick = async () => {
    try {
      await resendInvite({
        variables: {
          shareGoalInviteId: id,
        },
      });
    } catch {
      showErrorBanner();
    }
  };

  if (loading) {
    return (
      <div style={styles.loader}>
        <ActivityIndicator />
      </div>
    );
  }

  if (data?.resendInviteToShareGoal?.id) {
    return (
      <BodySmall style={{ ...styles.cta, ...styles.resent }}>
        {i18n.t(Translations.InviteItemSentLabel)}
      </BodySmall>
    );
  }

  return (
    <div style={styles.cta} onClick={onClick}>
      <BodySmall style={styles.resend}>{i18n.t(Translations.InviteItemResendLabel)}</BodySmall>
    </div>
  );
};
